import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BaseWidgetComponent } from '../base-widget/base-widget.component';

@Component({
    selector: 'app-vault-widget',
    templateUrl: './vault-widget.component.html',
    styleUrls: ['../base-widget/base-widget.component.scss', './vault-widget.component.scss'],
    standalone: false
})
export class VaultWidgetComponent extends BaseWidgetComponent implements OnInit {
  @Output() onPlayground = new EventEmitter<{ parentId: string; vaultName: string; workers: string[] }>();
  @Output() onEditFile = new EventEmitter<{ parentId: string; path: string }>();

  constructor() {
    super();
  }

  ngOnInit(): void {}

  playgroundClick($event: { parentId: string; vaultName: string; workers: string[] }) {
    this.onPlayground.emit({ parentId: this.id, vaultName: $event.vaultName, workers: $event.workers });
  }

  editFileClick($event: { parentId: string; path: string }) {
    this.onEditFile.emit({ parentId: this.id, path: $event.path });
  }
}
